export interface Authorization {
    id: string,
    clientId: string;
    clientSecret: string;
    url: string;
    redirectUri: string;
    scopes: string;
    username: string;
    password: string;
    createdOn: Date;
    modifiedOn: Date;
    flowType: FlowTypesEnum;
    refreshToken: string;
    credentialsName: string;
    tenantId: string;
    authorized: boolean;
    lastAuthorizationSuccessDate: Date | null;
    lastAuthorizationRequestDate: Date | null;
    lastErrorMessage: string;
}

export interface AuthorizationInfo {
    id: string,
    credentialsName: string;
    username: string;
    createdOn: Date;
    modifiedOn: Date;
    modifiedById: string;
    modifiedBy: string;
    flowType: FlowTypesEnum;
    lastAuthorizationSuccessDate: Date | null;
    lastAuthorizationRequestDate: Date | null;
}

export enum FlowTypesEnum
{
    AuthorizationCodeFlow,
    ClientCredentialFlow,
    ResourceOwnerPasswordCredentialsFlow
}
